import './domain-list.component.ajscss';

import { DomainResult, IHypervisionService } from '@hypervision/hypervision.service';
import { Domain } from '@hypervision/models/domain';
import {
  IChangesObject,
  IComponentController,
  IComponentOptions,
  IFilterService,
  ILogService,
  isDefined,
  isObject,
  isUndefined,
} from 'angular';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

import templateUrl from './domain-list.component.ajs.html';

class DomainListCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public selectedDomainId: string;
  public selectedIndicator;
  public showAggregated: boolean;
  private onChangeSelectedDomainId: Function;
  private onChangeShowAggregated: Function;

  public domains: Domain[] = [];
  public selectedDomain: Domain;
  public rootDomain: Domain;

  constructor(
    private readonly $filter: IFilterService,
    private readonly $log: ILogService,
    private readonly hypervision: IHypervisionService
  ) {
    super();
  }

  $onInit() {
    this.hypervision.onUpdated(updated => {
      this.$log.debug('[domain-list] updating ...');
      this.onResponse(updated);
    });
    this.init();
  }

  $onChanges(onChangesObj: { [property: string]: IChangesObject }) {
    if (onChangesObj['selectedDomainId'] && isDefined(onChangesObj['selectedDomainId'].currentValue)) {
      this.selectedDomainId = onChangesObj['selectedDomainId'].currentValue;
    }
    if (onChangesObj['selectedIndicator'] && isDefined(onChangesObj['selectedIndicator'].currentValue)) {
      this.selectedIndicator = onChangesObj['selectedIndicator'].currentValue;
      this.init();
    }
    if (onChangesObj['showAggregated'] && isDefined(onChangesObj['showAggregated'].currentValue)) {
      this.showAggregated = onChangesObj['showAggregated'].currentValue;
    }
  }

  private init() {
    this.hypervision.getDomainsMetrics().then(
      (success: DomainResult) => this.onResponse(success),
      error => this.$log.error('Failed: ' + error)
    );
  }

  private onResponse(response: DomainResult) {
    // SUCCESS
    this.domains = this.$filter('orderBy')(response.list, 'fullName', false);
    this.rootDomain = response.tree;
    if (isObject(this.rootDomain) && isUndefined(this.selectedDomainId)) {
      this.onSelectDomain({ selectedDomain: this.rootDomain });
    }
  }

  onSelectDomain({ selectedDomain }) {
    if (isUndefined(selectedDomain)) return;
    // Update currentDomain
    this.selectedDomain = selectedDomain;
    if (isObject(this.selectedDomain)) {
      this.onChangeSelectedDomainId({ $event: { selectedDomainId: this.selectedDomain.id } });
    }
  }

  toggleAggregated() {
    this.onChangeShowAggregated({ $event: { showAggregated: this.showAggregated } });
  }

  toggleAggregatedOn() {
    this.showAggregated = true;
    this.onChangeShowAggregated({ $event: { showAggregated: this.showAggregated } });
  }

  toggleAggregatedOff() {
    this.showAggregated = false;
    this.onChangeShowAggregated({ $event: { showAggregated: this.showAggregated } });
  }
}

export class DomainList implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    selectedDomainId: '<',
    selectedIndicator: '<',
    showAggregated: '<',
    onChangeSelectedDomainId: '&',
    onChangeShowAggregated: '&',
  };
  controller = ['$filter', '$log', 'hypervision', DomainListCtrl];
}

export default 'domainList';
